<template>
  <div class="add-wardrobe-product-button-container">
    <b-button
      size="md"
      :variant="variantName"
      class="add-item-btn mb-5"
      @click="submit()"
    >
      <span>{{ buttonText }}</span>
    </b-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  data() {
    return {
      text: "Create Outfit"
    };
  },

  methods: {
    ...mapActions(["setWardrobeBuilderMode"]),

    submit() {
      if (this.$router.currentRoute.name === "WardrobeClothes") {
        this.toggleBuilderMode();
      } else {
        this.$router.push({ name: "WardrobeClothes" }).then(() => {
          let _this = this;
          setTimeout(function() {
            _this.toggleBuilderMode();
          }, 200);
        });
      }
    },

    toggleBuilderMode() {
      this.wardrobeBuilderMode
        ? bus.$emit("cancelBuilderMode")
        : this.setWardrobeBuilderMode(true);
    }
  },

  computed: {
    ...mapGetters(["wardrobeBuilderMode"]),

    buttonText() {
      return this.wardrobeBuilderMode ? "Cancel outfit" : this.text;
    },

    variantName() {
      return this.wardrobeBuilderMode ? "outline-unstitched" : "unstitched";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.add-wardrobe-product-button-container {
  .add-item-btn {
    border-radius: 0;
    padding: 15px;
    font-size: 11px;
    letter-spacing: 1.4px;

    &:hover {
      box-shadow: 0 8px 24px rgba($primary-blue, 0.25);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/buttons/CreateWardrobeOutfitButton.vue